"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectDeliveryFrequency = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _hooks = require("../../../../hooks");
var _context = require("../../context");
var _constants = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const SelectDeliveryFrequency = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    control
  } = (0, _reactHookForm.useFormContext)();
  const {
    deliveryFrequencyOptions,
    recommendedFrequency
  } = (0, _context.useSubscriptionModule)();
  const options = (0, _react.useMemo)(() => (0, _utils.mapFrequencyDeliveryOptions)({
    deliveryFrequencyOptions,
    recommendedFrequency,
    translations
  }), [deliveryFrequencyOptions, recommendedFrequency, translations]);
  const renderSelect = (0, _react.useCallback)(({
    field
  }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Select, {
    ...field,
    id: "frequency",
    size: "medium",
    children: options.map(({
      label,
      value
    }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.MenuItem, {
      value: value,
      children: label
    }, value))
  }), [options]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.SELECT_DELIVERY_FREQUENCY),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      component: "label",
      htmlFor: "frequency",
      children: translations.deliveryFrequencyLabel
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
      name: "frequency",
      control: control,
      defaultValue: recommendedFrequency,
      render: renderSelect
    })]
  });
};
exports.SelectDeliveryFrequency = SelectDeliveryFrequency;
